import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Inner from './Inner';
import logo from '../assets/logo-no-background.png';
import { useAppSelector, useAppDispatch } from '../hooks/useRedux';
import { logout } from '../store/authSlice';
import { User } from '../store/usersSlice';
import Badge from '@mui/material/Badge';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import { Mobile, Tablet, Desktop } from '../utils/MediaQuery';
import MenuIcon from '@mui/icons-material/Menu';
import ResponsiveMenu from './ResponsiveMenu';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';

const Wrapper = styled.div`
  height: 75px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  border-bottom: 1px solid #dee2e6;
  z-index: 999;
`;

const Container = styled(Inner)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const LeftWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const RightWrapper = styled.div`
  margin-left: auto;
`;

const LogoWrapper = styled.div`
  width: 8rem;

  img {
    width: 100%;
    height: auto;
  }
`;

const LoginMessage = styled.div`
  margin-left: 4rem;

  strong {
    font-weight: 700;
  }
`;

const Nav = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;
  font-size: 1.1rem;
`;

const List = styled.div`
  cursor: pointer;

  & + & {
    margin-left: 2rem;
  }
`;

// Responsive
const MobileWrapper = styled.div`
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const TabletLeftWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const MenuButton = styled.div`
  cursor: pointer;
`;

const CloseButton = styled.div`
  cursor: pointer;
`;

function Header() {
  const isLogin = useAppSelector((state) => state.auth.isLogin);
  const user = useAppSelector((state) => state.auth.user) as User;
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuButton = () => {
    setIsMenuOpen(true);
  };

  const handleCloseButton = () => {
    setIsMenuOpen(false);
  };

  const handleToggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  return (
    <>
      <Mobile>
        <Wrapper>
          <MobileWrapper>
            <LogoWrapper>
              <Link to='/'>
                <img src={logo} alt='Logo' />
              </Link>
            </LogoWrapper>
            {isMenuOpen ? (
              <CloseButton onClick={handleCloseButton}>
                <CloseIcon sx={{ fontSize: '2.2rem' }} />
              </CloseButton>
            ) : (
              <MenuButton onClick={handleMenuButton}>
                <MenuIcon sx={{ fontSize: '2.2rem' }} />
              </MenuButton>
            )}
          </MobileWrapper>
        </Wrapper>
        {isMenuOpen && <ResponsiveMenu handleToggleMenu={handleToggleMenu} />}
      </Mobile>

      <Tablet>
        <Wrapper>
          <Container>
            <TabletLeftWrapper>
              <LogoWrapper>
                <Link to='/'>
                  <img src={logo} alt='Logo' />
                </Link>
              </LogoWrapper>
              {isLogin && (
                <LoginMessage>
                  안녕하세요, <strong>{`${user.id}`}</strong> 님.
                </LoginMessage>
              )}
            </TabletLeftWrapper>
            {isMenuOpen ? (
              <CloseButton onClick={handleCloseButton}>
                <CloseIcon sx={{ fontSize: '2.2rem' }} />
              </CloseButton>
            ) : (
              <MenuButton onClick={handleMenuButton}>
                <MenuIcon sx={{ fontSize: '2.2rem' }} />
              </MenuButton>
            )}
          </Container>
        </Wrapper>
        {isMenuOpen && <ResponsiveMenu handleToggleMenu={handleToggleMenu} />}
      </Tablet>

      <Desktop>
        <Wrapper>
          <Container>
            <LeftWrapper>
              <LogoWrapper>
                <Link to='/'>
                  <img src={logo} alt='Logo' />
                </Link>
              </LogoWrapper>
              {isLogin && (
                <LoginMessage>
                  안녕하세요, <strong>{`${user.id}`}</strong> 님.
                </LoginMessage>
              )}
            </LeftWrapper>
            <RightWrapper>
              <Nav>
                <List>
                  <Link to='/exhibition'>Exhibition</Link>
                </List>
                <List>
                  <Link to='/artists'>Artists</Link>
                </List>
                <List>
                  <Link to='/goods'>Goods</Link>
                </List>
                {!isLogin ? (
                  <>
                    <List>
                      <Link to='/signup'>Sign Up</Link>
                    </List>
                    <List>
                      <Link to='/signin'>Sign In</Link>
                    </List>
                  </>
                ) : (
                  <>
                    <List>
                      <Link to='/cart'>
                        <Badge badgeContent={user.cart?.length} color='primary'>
                          <ShoppingCartOutlinedIcon sx={{ fontSize: 34 }} />
                        </Badge>
                      </Link>
                    </List>
                    <List
                      onClick={() => {
                        dispatch(logout());
                        return navigate('/');
                      }}
                    >
                      Sign Out
                    </List>
                  </>
                )}
              </Nav>
            </RightWrapper>
          </Container>
        </Wrapper>
      </Desktop>
    </>
  );
}

export default Header;
